import { render } from "./AskDoubtassTeacher.vue?vue&type=template&id=3fbb723c&scoped=true"
import script from "./AskDoubtassTeacher.vue?vue&type=script&lang=js"
export * from "./AskDoubtassTeacher.vue?vue&type=script&lang=js"

import "./AskDoubtassTeacher.vue?vue&type=style&index=0&id=3fbb723c&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbb723c"]])

export default __exports__